/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function o(o,t,n){return o.customToolOptions=t,n&&(o.customActions=n),o}function t(o){o.dismissFloatingElements()}function n(o,t){return o.contextualToolLocation=t,o}function i(o,t){return o.groupCollapsePriorities=t,o}export{t as dismissFloatingElements,n as setContextualToolLocation,o as setCustomTools,i as setGroupCollapsePriorities};
